import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Formik, Field as Fieldmik } from 'formik';
import { Form as FormUi, Segment, Button, Checkbox } from 'semantic-ui-react';
import * as yup from 'yup';
import moment from 'moment';
import AddTitleBar from '../../../titleBar/add_titleBar';
import LoadingPlaceholder from '../../../placeholderComponent/loadingPlaceholder';
// import { Checkbox } from 'formik-semantic-ui';
import Axios from 'axios';
import APP_CONSTANTS from '../../../../config/constants';


//Inputs
import { DateData } from '../../../formikInput/date';
import FileUpload from '../../../formikInput/uploadFile';

//Add-Product
import AddProduct from '../../../purchaseOrder/addProduct';
import ActivePurchaseOrder from './activePurchaseOrder';
import SupportingDoc from './supportingDoc';


//Dropdowns
import PurchaseOrderVendorDropdown from '../../../dropdowns/purchaseOrderVendorDropdown';
import PurchaseOrderBranchDropdown from '../../../dropdowns/purchaseOrderBranchDropdown';
import BranchDropdown from '../../../dropdowns/branchDropdown';
import VehicleDropdown from '../../../dropdowns/vehicleDropdown';

//Actions 
import { store } from '../../../../redux/store/store';

import { createBill } from '../../../../redux/actions/billActions';
import { getVendorPurchaseOrder, updatePurchaseOrder } from '../../../../redux/actions/purchaseOrderActions';
import ReadAxios from '../../../axiosComponent/read';
import { FEATURES } from '../../../../utils/constant';


const AddBill = (props) => {

    const { createBill, getVendorPurchaseOrder, vendorPurchaseOrderData, purchaseOrderLoading, updatePurchaseOrder } = props;

    //State
    const [activateManualPO, setActivateManualPO] = useState(false);
    const [initialize, setInitialize] = useState(false)
    const [vehicleData, setVehicleData] = useState([]);
    const [vendorName, setVendorName] = useState(localStorage.getItem("vendorCode"));
    const [vendorDetails, setVendorDetails] = useState([])
    const [VendorState, setVendorState] = useState('');
    const [vendorStateId, setVendorStateId] = useState('');
    const [branchCode, setBranchCode] = useState('');
    const [masterBranch, setMasterBranch] = useState("");
    const [billNumber, setBillNumber] = useState("");

    const [masterState, setMasterState] = useState('');
    const [vendorBranchData, setVendorBranchData] = useState([])
    const [stateData, setStateData] = useState([]);
    const [gst, setGst] = useState([]);
    const [orderLoading, setOrderLoading] = useState(false);

    const [orderDetails, setorderDetails] = useState([])
    const [billDate, setBillDate] = useState(null)
    const [ExpectedPaymentDate, setExpectedPaymentDate] = useState(null)
    const [UploadedFile, setUploadedFile] = useState(null)
    const [RefNumber, setRefNumber] = useState(null)
    const [isGSTApplicable, setIsGSTApplicable] = useState(false)
    const [DocValues, setDocValues] = useState([{
        billId: "0",
        supportingDocumentTypeId: "0",
        supportingDocumentTypeName: "",
        fileUrl: ""
    }])

    const [currentPageNoProp, setCurrentPageNoProp] = useState(1);
    const [totalPagesPresentProp, setTotalPagesPresentProp] = useState(1);

    const [searchText, setSearchText] = useState('');


    const getVehicleData = childData => {
        setVehicleData(childData)
    }

    //ArrayHelper	
    Array.prototype.sum = function (prop) {
        var total = 0
        for (var i = 0, _len = this.length; i < _len; i++) {
            total += this[i][prop]
        }
        return total
    }


    //UseEffect
    useEffect(() => {
        setInitialize(true)
        setOrderLoading(true)
        getData()
    }, [])

    let getData = async () => {
        await getVendorPurchaseOrder(vendorName, 1)
        await setData()

    }

    const setData = () => {
        let getPurchaseOrderState = store.getState().getPurchaseOrderReducer.purchaseOrder.data;
        let getPurchaseOrderPageState = store.getState().getPurchaseOrderReducer.purchaseOrder.pagination;

        if (getPurchaseOrderPageState?.totalPages)
            setTotalPagesPresentProp(getPurchaseOrderPageState.totalPages)
        formatPODetails(getPurchaseOrderState).then(() => { setInitialize(false); setOrderLoading(false); })

        let token = localStorage.getItem('isloggedIn')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNumber')

        let vendorId = localStorage.getItem('vendorId')

        Axios.get(`${APP_CONSTANTS.BASE_URL}masters/vendorDetails/${vendorId}?customerNumber=${customerNo}&userId=${userId}`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        })
            .then((response => {
                setVendorBranchData(response.data.resultSet.branches)
                setVendorDetails(response.data.resultSet)

            }))
            .catch((error => {
                console.log(error)

            }))

        Axios.get(`${APP_CONSTANTS.BASE_URL}/masters/stateMaster?customerNumber=${customerNo}&userId=${userId}`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setStateData(response.data.resultSet)
        }))
            .catch(error => console.log(error))
    }

    let formatPODetails = async (data) => {
        let arr = []
        if (data != null && data != undefined) {
            for (const [index, o] of data.entries()) {
                const response = await ReadAxios({
                    completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/billing/${o.poId}`,
                })
                // if (response.data.data != null) {
                let temp = {}
                temp.poId = o.poId
                temp.poReferenceNo = o.poReferenceNo
                temp.order_date = response.data.data == null ? 'N/A' : response.data.data.order_date
                temp.order_reference_no = response.data.data == null ? 'N/A' : response.data.data.order_reference_no
                temp.lr_no = response.data?.data?.deliveries?.[0]?.lr_number ? response.data.data.deliveries[0].lr_number : 'N/A'
                temp.vendor_lr_no = response.data.data == null ? 'N/A' : response.data.data.vendor_lr_numbers && response.data.data.vendor_lr_numbers.join(", ")
                temp.delivery_status = response?.data?.data?.deliveries?.[0]?.delivery_status ? response.data.data.deliveries[0].delivery_status : 'N/A'
                temp.checkbox = false
                temp.vendorCode = o.vendorId
                temp.branchCode = o.branchId
                temp.vehicleNo = o.vehicleId
                temp.poQuantity = o.poQuantity
                temp.poAmount = o.poAmount
                temp.poNumber = o.poNumber
                temp.deliveryDate = o.deliveryDate ? o.deliveryDate : ''
                temp.sgstAmount = o.sgstAmount
                temp.cgstAmount = o.cgstAmount
                temp.igstAmount = o.igstAmount
                temp.adjustment = o.adjustment
                temp.totalOrderAmt = o.totalOrderAmt
                temp.remarks = o.remarks
                temp.gstTaxType = o.gstTaxType
                temp.poDate = o.poDate
                temp.tdsAmount = o.tdsAmount
                temp.taxableAmount = o.taxableAmount
                temp.totalDiscount = o.totalDiscount
                temp.remarksList = []
                if (response?.data?.data?.deliveries && response?.data?.data?.deliveries?.length > 0) {
                    response.data.data.deliveries.forEach(element => {
                        if (element?.remarks)
                            temp.remarksList.push(element.remarks)
                    });
                }
                if(temp.remarksList.length === 0){
                    response?.data?.data?.order_remarks && temp.remarksList.push(response.data.data.order_remarks)
                }
                arr[index] = temp
            }
        }
        setorderDetails(arr)

    }

    let handleOrderRefresh = (data) => {
        setOrderLoading(true)
        if (data) {
            setInitialize(true)
            setOrderLoading(true)
            getData()
        }
    }

    let handlePageRefresh = (pageNo) => {
        if (pageNo) {
            setInitialize(true)
            setOrderLoading(true)
            getDataWithPageChange()
        }
    }

    let handlePaginationChange = (pageNo) => {
        setCurrentPageNoProp(pageNo)
        if (searchText?.length > 0)
            getVendorPurchaseOrder(vendorName, pageNo, searchText)
        else
            getVendorPurchaseOrder(vendorName, pageNo)
        setOrderLoading(true)
        setTimeout(() => {
            handlePageRefresh(pageNo)
        }, 3000);

    }

    let handleSearchString = (searchString) => {
        setSearchText(searchString)
        setCurrentPageNoProp(1)
        getVendorPurchaseOrder(vendorName, 1, searchString)
        setOrderLoading(true)
        setTimeout(() => {
            handlePageRefresh(1)
        }, 3000);
    }

    let getDataWithPageChange = () => {
        let getPurchaseOrderState = store.getState().getPurchaseOrderReducer.purchaseOrder.data;

        formatPODetails(getPurchaseOrderState).then(() => { setInitialize(false); setOrderLoading(false); })

        let getPurchaseOrderPageState = store.getState().getPurchaseOrderReducer.purchaseOrder.pagination;
        if (getPurchaseOrderPageState?.totalPages)
            setTotalPagesPresentProp(getPurchaseOrderPageState.totalPages)


        let token = localStorage.getItem('isloggedIn')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNumber')

        let vendorId = localStorage.getItem('vendorId')

        Axios.get(`${APP_CONSTANTS.BASE_URL}masters/vendorDetails/${vendorId}?customerNumber=${customerNo}&userId=${userId}`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        })
            .then((response => {
                setVendorBranchData(response.data.resultSet.branches)
                setVendorDetails(response.data.resultSet)

            }))
            .catch((error => {
                console.log(error)

            }))

        Axios.get(`${APP_CONSTANTS.BASE_URL}/masters/stateMaster?customerNumber=${customerNo}&userId=${userId}`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setStateData(response.data.resultSet)
        }))
            .catch(error => console.log(error))

    }

    // return data.forEach(async (element, index) => {
    //     let resp = await ReadAxios({
    //         completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/billing/${element.poId}`,
    //     })

    //     if (resp.data.data != null) {
    //         return resp.data.data
    //     }


    // })
    // return data.map(async (object, idx) => {
    //     console.log('>>', response.data.message)

    // })
    // element.poId

    // console.log('Bill Fetch', response)
    // if (response) {
    //     console.log(response.data.data)
    // }
    // .then((res) => {
    //     console.log('orderDetails', res.data.data)
    //     // if (res.data.data) {
    //     //     temp.order_date = res.data.data.order_date
    //     //     temp.order_reference_no = res.data.data.order_reference_no
    //     //     temp.lr_no = res.data.data.deliveries[0].lr_number
    //     //     temp.delivery_status = res.data.data.deliveries[0].delivery_status
    //     // }
    // })

    //Existing PO Array

    let activePOData = [];


    //Formik
    const initialValues = {
        vendorName: vendorName,
        billNumber: billNumber,
        billDate: billDate,
        expectedPaymentDate: ExpectedPaymentDate,
        billReceiptDate: '',
        branch: masterBranch,
        vendorBranch: branchCode,
        poReferenceNo: '',
        vehicleNo: '',
        billReferenceNo: RefNumber,
        activePoAddedTotal: '',
        isGstApplicable: isGSTApplicable,
        manualPoAddedTotal: '',
        productDetails: [{
            productName: '',
            startDate: '',
            endDate: '',
            hsnCode: '',
            sacCode: '',
            quantity: 1,
            rate: '',
            discount: '',
            discountType: "1",
            isAdditionalCharge: '',
            iGstPercent: 0,
            iGst: 0,
            cGstPercent: 0,
            cGst: 0,
            sGstPercent: 0,
            sGst: 0,
            amount: 0,
        }],
        supportDoc: DocValues,
        activePODetails: orderDetails,
        fileUpload: UploadedFile,
        fileSize: '',
        finalAmount: '',
        activePOSelected: [],
    }

    const validateSchema = yup.object().shape({
        vendorName: yup.mixed().required('Partner Name is Required'),
        billDate: yup.mixed().required('Bill Date is Required'),
        branch: yup.mixed().required('Branch is Required'),
        expectedPaymentDate: yup.mixed().required('Expected Payment Date is Required'),
        billReferenceNo: yup.mixed().required('Bill Reference Number is Required'),
        fileUpload: yup.mixed().when(['fileSize'], (fileSize, schema) => {
            return fileSize ? schema.test("fileSize", "File size should be less than 5MB", (value) => {
                return value && value.fileList[0].size <= 5000000
            })
                :
                schema
        })
    })

    const onSubmit = (values, onSubmitProps) => {
        const customerNumber = localStorage.getItem('customerNumber');
        const userId = localStorage.getItem('userId');
        let psLineItems = [];
        values.productDetails.map((product, index) => {
            let temp = {}
            temp.psCode = product.productCode
            temp.psName = product.productName
            temp.startDate = product.startDate
            temp.endDate = product.endDate
            temp.psQty = product.quantity
            temp.psPrice = product.rate
            temp.psAmount = product.rate * product.quantity
            temp.igstPercent = product.iGstPercent
            temp.igstAmount = product.iGst
            temp.cgstPercent = product.cGstPercent
            temp.cgstAmount = product.cGst
            temp.sgstPercent = product.sGstPercent
            temp.sgstAmount = product.sGst
            temp.tdsCode = 9
            temp.discount = product.discount
            temp.finalDiscount = product.discount
            temp.discountType = product.discountType
            temp.taxableAmount = product.rate * product.quantity - product.discount
            psLineItems[index] = temp
        });

        let exLineItems = [];
        values.activePOSelected.map((product, index) => {
            let temp = {}
            temp.poReferenceNo = product.poReferenceNo
            exLineItems[index] = temp
        })

        let supportingDocArray = [];
        values.supportDoc.map((document, documentIndex) => {
            let temp = {}
            temp.supportingDocumentTypeName = document.supportingDocumentTypeName
            temp.supportingDocumentTypeId = document.supportingDocumentTypeId
            supportingDocArray[documentIndex] = temp
        })

        let manualPoArray = [
            {
                poReferenceNo: "",
                vendorCode: values.vendorName,
                branchCode: values.vendorBranch,
                vehicleNo: "",
                poQuantity: psLineItems.length,
                poAmount: values.finalAmount,
                sgstAmount: psLineItems.sum('sgstAmount'),
                cgstAmount: psLineItems.sum('cgstAmount'),
                igstAmount: psLineItems.sum('igstAmount'),
                adjustment: 0,
                totalOrderAmt: values.finalAmount,
                remarks: '',
                gstTaxType: 0,
                poDate: new Date(),
                tdsAmount: 0,
                taxableAmount: psLineItems.sum('taxableAmount'),
                totalDiscount: psLineItems.sum('discount'),
                psDetails: psLineItems
            }
        ]

        console.log("here in 1");


        if (values.poQuantity === 0) {
            console.log("here in 0");
            manualPoArray = []
        }
        console.log("here in 00");


        // if (activateManualPO) {
        //     exLineItems = [];
        // } else {
        //     manualPoArray = [];
        // }
        let remarkListString = '';
        let remarkList = [];

        values.activePOSelected.forEach(element => {
            if (element?.remarksList && element?.remarksList?.length > 0)
                remarkList = remarkList.concat(element.remarksList)
        });

        remarkListString = remarkList.length > 0 ? remarkList.join(',') : ''

        const createBillData = {
            customerNo: customerNumber,
            userId: userId,
            billReferenceNo: '',
            billNo: values.billNumber,
            vendorCode: vendorName,
            billAmount: values.finalAmount,
            statusCode: '',
            fileUpload: values.fileUpload ? values.fileUpload.base64.split(',')[1] : '',
            isGstApplicable: values.isGstApplicable ? "1" : "0",
            expectedPaymentDate: moment(values.expectedPaymentDate).format("DD-MM-YYYY"),
            billReferenceNo: values.billReferenceNo,
            billDate: moment(values.billDate).format("DD-MM-YYYY"),
            totalPoAmount: values.finalAmount,
            termsConditions: '',
            remarks: remarkListString,
            branchCode: masterBranch,
            vendorBranchCode: branchCode,
            gstTaxType: 2,
            totalTaxableAmount: 0,
            totalSgstAmount: manualPoArray ? manualPoArray.sgstAmount : '',
            totalCgstAmount: manualPoArray ? manualPoArray.cgstAmount : '',
            totalIgstAmount: manualPoArray ? manualPoArray.igstAmount : '',
            totalTdsAmount: 0,
            departMentCategoryCode: 0,
            irn: '',
            hsnCode: '',
            noOfLineItems: psLineItems.length,
            isPartialBill: 0,
            grn: '',
            grnDateTime: '',
            billReceiptDate: '',
            poDate: '',
            totalOrderAmt: values.finalAmount,
            adjustment: 0,
            poAmount: values.amount,
            poQuantity: 1,
            tdsAmount: 0,
            taxableAmount: 2,
            totalDiscount: 0,
            existingPoArray: exLineItems,
            manualPoArray: [],
            supportingDocumentTypeArray: supportingDocArray
        };
        createBill(createBillData).then(() => {
            setTimeout(() => { onSubmitProps.setSubmitting(false) }, 4000)
        });
    };

    const getBranchSelected = childData => {
        const branchDetails = vendorDetails.branches.find(data => data.vendorBranchCode === childData);
        const stateDetails = stateData.find(data => data.stateId === branchDetails.vendorBranchStateId);
        console.log("Branch Value", childData, branchDetails, stateDetails)


        console.log("branch Details", branchDetails)

        //Set GST and VendorState from Branch Selected
        setGst(branchDetails.vendorBranchGST);
        setVendorState(stateDetails.state);
        setVendorStateId(stateDetails.stateId)
        setBranchCode(branchDetails.vendorBranchCode);
    };

    const getMasterBranchSelected = (branchId, branchData, setFieldValue) => {
        const addedMasterBranchObject = branchData.find(data => data.branchId === branchId)
        setMasterState(addedMasterBranchObject && addedMasterBranchObject.stateId)
        console.log("Branch Data", branchCode, branchData, addedMasterBranchObject)
        setMasterBranch(addedMasterBranchObject && addedMasterBranchObject.branchCode)


        let token = localStorage.getItem('isloggedIn')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNumber')

        let headerData = {
            "customerNo": customerNo,
            "userId": userId,
            "branchCode": addedMasterBranchObject && addedMasterBranchObject.branchCode
        }

        Axios.post(`${APP_CONSTANTS.BASE_URL}/purchase/bill/getBillNumber`, headerData, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setFieldValue("billNumber", response.data.data)
            setBillNumber(response.data.data)

        }))
            .catch(error => console.log(error))

    }


    let vendorLabel = {}
    const customerNo = localStorage.getItem('customerNumber')

    if (customerNo != 1158) {
        vendorLabel.vendorName = "Vendor Name"
        vendorLabel.vendorBranch = "Vendor Branch"
    } else {
        vendorLabel.vendorName = "Partner Name"
        vendorLabel.vendorBranch = "Partner Branch"
    }

    return (
        <React.Fragment>
            <AddTitleBar title="New Bill" LinkName="/bill" />
            <div className="m-2">
                <Formik
                    enableReinitialize={initialize}
                    initialValues={initialValues}
                    validationSchema={validateSchema}
                    onSubmit={onSubmit}>
                    {({ touched, errors, values, isSubmitting, setFieldValue, handleSubmit }) => {

                        values.fileSize = values.fileUpload && values.fileUpload.fileList ? values.fileUpload.fileList[0].size : ""
                        return (
                            <>
                                {
                                    values.supportDoc.length > 0 && values.supportDoc[0].supportingDocumentTypeName != '' ? setDocValues(values.supportDoc) : null
                                }
                                <Segment>
                                    <div className="ui form">
                                        <FormUi.Group >
                                            <FormUi.Field width="4">
                                                <label className="labelName mt-2">{vendorLabel.vendorName}</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="3">
                                                <Fieldmik component={PurchaseOrderVendorDropdown} name="vendorName" placeholder="Partner Name" getVendorPurchaseOrder={getVendorPurchaseOrder} value={vendorName} getVehicleData={getVehicleData} setInitialize={setInitialize} disabled />
                                                {touched.vendorName && errors.vendorName ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.vendorName}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">{vendorLabel.vendorBranch}</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="3">
                                                <Fieldmik component={PurchaseOrderBranchDropdown} name="vendorBranch" getBranchSelected={getBranchSelected} branchData={vendorBranchData} />
                                                {touched.vendorBranch && errors.vendorBranch ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.vendorBranch}</strong> : ''}
                                            </FormUi.Field>

                                        </FormUi.Group>
                                        <FormUi.Group>
                                            <FormUi.Field width="4">
                                                <label className="labelName mt-2">Bill Date</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="3">
                                                <DateData
                                                    name={`billDate`}
                                                    autoComplete="off"
                                                    popperClassName="dateTime"
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Date"
                                                    selected={values.billDate}
                                                    onChangeExtra={(val) => {
                                                        setBillDate(val);
                                                        if(FEATURES.isDefaultExpectedPaymentDateNeededInCreateBill){
                                                            setFieldValue("expectedPaymentDate", new Date(moment(val).add(60, 'days')))
                                                        }
                                                    }}
                                                    maxDate={new Date()}
                                                    timeIntervals={5}
                                                    customInput={<FormUi.Input error={values.billDate ? false : true} autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                />
                                                {touched.billDate && errors.billDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.billDate}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Branch</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="3">
                                                <Fieldmik component={BranchDropdown} name="branch" placeholder="Branch" getMasterBranchSelected={getMasterBranchSelected} />
                                                {touched.branch && errors.branch ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.branch}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group >
                                            <FormUi.Field width="4">
                                                <label className="labelName mt-2">Bill Number</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="3">
                                                <Fieldmik name="billNumber" placeholder="Bill Number" readOnly />
                                                {touched.billNumber && errors.billNumber ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.billNumber}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Expected Payment Date</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="3">
                                                <DateData
                                                    name={`expectedPaymentDate`}
                                                    autoComplete="off"
                                                    popperClassName="dateTime"
                                                    disabled={FEATURES.isExpectedPaymentDateDisabledInCreateBill}
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Date"
                                                    selected={values.expectedPaymentDate}
                                                    onChangeExtra={(val) => setExpectedPaymentDate(val)}
                                                    minDate={values.billDate}
                                                    timeIntervals={5}
                                                    customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                />
                                                {touched.expectedPaymentDate && errors.expectedPaymentDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.expectedPaymentDate}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />

                                        </FormUi.Group>
                                        <FormUi.Group>
                                            <FormUi.Field width="4">
                                                <label className="labelName mt-2">Bill Reference Number</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="3">
                                                <Fieldmik onChange={(e) => {
                                                    setRefNumber(e.target.value)
                                                    setFieldValue("billReferenceNo", e.target.value)
                                                }} name="billReferenceNo" placeholder="Reference Number" />
                                                {touched.billReferenceNo && errors.billReferenceNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.billReferenceNo}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />

                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Upload Invoice</label>
                                            </FormUi.Field>

                                            <FormUi.Field width="4">
                                                <Fieldmik component={FileUpload} uploadedFile={setUploadedFile} name="fileUpload" size="medium" typer={[".pdf"]} value={values.fileUpload} buttonName={values.fileUpload ? "Selected" : "Select"} />
                                                {values.fileUpload ? <strong className="w3-text-blue w3-tiny font-weight-bold">{values.fileUpload.fileList[0].name}</strong> : ""}<br />
                                                {/* {touched.fileUpload && errors.fileUpload ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.fileUpload}</strong> : ''} */}
                                                {values.fileSize && values.fileSize >= 5000000 ? <strong className="w3-text-red w3-tiny font-weight-bold">File size should be less than 5MB</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group>
                                            <FormUi.Field width="4">
                                                <label className="labelName mt-2">Is GST Applicable?</label>
                                            </FormUi.Field>
                                            <FormUi.Field className="labelName mt-2">
                                                <Checkbox
                                                    name={`isGstApplicable`}
                                                    value={values.isGstApplicable}
                                                    onChange={(e, { checked }) => setIsGSTApplicable(checked)}
                                                />
                                            </FormUi.Field>
                                        </FormUi.Group>

                                    </div>
                                </Segment>

                                <Segment compact>
                                    <SupportingDoc />
                                </Segment>

                                {
                                    orderLoading ?

                                        <React.Fragment>
                                            <LoadingPlaceholder />
                                        </React.Fragment>
                                        :
                                        <Segment>
                                            <div className="ui form">
                                                <Button
                                                    type="button"
                                                    onClick={() => { setActivateManualPO(false); setInitialize(false) }}
                                                    style={{ borderRadius: "5px 5px 0px 0px" }}
                                                    size="small"
                                                    toggle
                                                    active={!activateManualPO}
                                                >
                                                    Active Orders
                                                </Button>
                                                {/* <Button
                                                    type="button"
                                                    onClick={() => { setActivateManualPO(true); setInitialize(false) }}
                                                    style={{ borderRadius: "5px 5px 0px 0px" }}
                                                    size="small"
                                                    toggle
                                                    active={activateManualPO}
                                                >
                                                    Additional Charges
                                                </Button> */}
                                                {/* FieldArray Component */}
                                                {activateManualPO ?
                                                    <>
                                                        {/* <Container className="m-2">
                                                            <FormUi.Group >
                                                                <FormUi.Field width="3">
                                                                    <label className="labelName mt-2">Vehicle Number</label>
                                                                </FormUi.Field>
                                                                <FormUi.Field width="3">
                                                                    <Fieldmik component={VehicleDropdown} name="vehicleNumber" placeholder="Vehicle Number" vehicleData={vehicleData} value={values.vehicleNumber} />
                                                                    {touched.vehicleNumber && errors.vehicleNumber ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.vehicleNumber}</strong> : ''}
                                                                </FormUi.Field>
                                                                <FormUi.Field width="2" />
                                                                <FormUi.Field width="3">
                                                                    <label className="labelName mt-2">PO Reference Number</label>
                                                                </FormUi.Field>
                                                                <FormUi.Field width="3">
                                                                    <Fieldmik name="poReferenceNo" placeholder="Reference Number" />
                                                                    {touched.poReferenceNo && errors.poReferenceNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.poReferenceNo}</strong> : ''}
                                                                </FormUi.Field>
                                                            </FormUi.Group>
                                                        </Container> */}
                                                        <AddProduct billmode={true} />
                                                    </>
                                                    :
                                                    <ActivePurchaseOrder
                                                        refreshedOrder={handleOrderRefresh}
                                                        masterState={masterState}
                                                        vendorStateId={vendorStateId}
                                                        updatePurchaseOrder={updatePurchaseOrder}
                                                        masterBranch={masterBranch}
                                                        orderDetails={orderDetails}
                                                        handlePaginationChangeAPI={handlePaginationChange}
                                                        currentPageNoProp={currentPageNoProp}
                                                        totalPagesPresentProp={totalPagesPresentProp}
                                                        handleSearchString={handleSearchString}
                                                        searchTextProps={searchText}
                                                    />
                                                }

                                            </div>
                                        </Segment>

                                }
                                <center><Button disabled={isSubmitting} onClick={handleSubmit} size='mini' primary type='submit' className='margin-bottom-70 mt-4'>Submit</Button></center>
                            </>
                        )
                    }}
                </Formik>
            </div>
        </React.Fragment>
    )
}


const mapStatetoProps = state => ({
    vendorPurchaseOrderData: state.getPurchaseOrderReducer.purchaseOrder.data,
    vendorPurchaseOrderLoading: state.getPurchaseOrderReducer.isLoading
})

export default connect(mapStatetoProps, { createBill, getVendorPurchaseOrder, updatePurchaseOrder })(AddBill)


